module.exports = __webpack_public_path__ + "img/s2p.3db7879e.svg";